const customEvent = {
  methods: {
    customEvent(e) {
      if (this.column?.customEvent) {
        const {
          customEventName
        } = this.column
        window.workFlow[customEventName].bind(
          this,
          e,
          this.viewFormData.options.column,
          this.viewFormData.modelData,
          this.viewFormData,
          {
            column: this.column,
            value: this.value
          }
        )()
      }
    }
  }
}

export default customEvent
